import { LOCALES } from '../constants';


export default {
  [LOCALES.SPANISH]: {
    'edit-file': 'Edit {file} and save to reload.',
    'hello': 'Hola! soy',
    'language': 'ES',
    'im': 'Soy un ',
    'listim': 'Amante de perros',
    'Intro': 'Intro',
    'Portfolio': 'Portafolio',
    'Skills': 'Habilidades',
    'contact': 'Contacto',
    'Featured': 'Destacados',
    'Web App': 'Desarrollo Web',
    'Mobile App': 'Desarrollo Mobil',
    'Design': 'Diseño',
    'Data':'Data',
    'bungo': 'BungoMyDingo es un proyecto en donde tengo mis ilustraciones, variando desde la primera imagen que se me venga a la cabeza hasta mis perritos!',
    'click':'Click aquí para ver más!',
    'kimberly': 'Realice mis practicas profesionales en Kimberly Klark, generando estructuras de datos para su análisis y creando interfaces graficas que permiten la optimización de maquinas para un mejor desempeño.',
    'next':'Proximamente!',
    'developing' : 'Actualmente estoy trabajando en muchos nuevos proyectos para mostrar! :D',
    'discord msg': 'Escribeme en Discord!',
    'instagram msg': 'Sigueme en Instagram!',
    'linkedin msg': 'Encuentrame en Linkedin!',
    'hv msg': 'Descarga mi hoja de vida!',
    'contact msg': 'Contactame',
    'msg': 'mensaje',
    'send msg': 'enviar',
    'thanks msg': 'Gracias! responderé lo más pronto posible',
  },
};